import RecipeImportPage from '@/components/pages/RecipeImportPage';
export default function ImportRecipesPage() { return <RecipeImportPage />; }
